import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import MessagePropType from '../definitions/MessagePropType';
import Sizes from '../definitions/Sizes';
import Paragraph from './Paragraph';
import CalculationLine from './CalculationLine';
import { LOCATION_OPTIONS, ALIGNMENT_OPTIONS } from './Tooltip';


function CalculationLineBlock({ title, formulas, ...otherProps }) {
    return (
        <CalculationLineBlock.Container {...otherProps}>
            <If condition={title}>
                <Paragraph
                    message={title}
                    size="medium"
                    weight="medium"
                />
            </If>

            <For
                each="formula"
                of={formulas}
            >
                <CalculationLine
                    key={`${formula.id}-value`}
                    isVisible={formula.isVisible}
                    id={formula.id}
                    name={formula.name}
                    label={formula.label}

                    operandValue={formula.operandValue}
                    operandFormat={formula.operandFormat}

                    operator={formula.operator}

                    tooltipMessage={formula.tooltipMessage}
                    tooltipWidth={formula.tooltipWidth}
                    tooltipLocation={formula.tooltipLocation}
                    nubbinAlignment={formula.nubbinAlignment}

                    result={formula.result}
                />
            </For>
        </CalculationLineBlock.Container>
    );
}

CalculationLineBlock.propTypes = {
    title: MessagePropType,
    formulas: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string,
        isVisible: PropTypes.bool,
        label: MessagePropType.isRequired,

        operandValue: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
            PropTypes.func,
        ]).isRequired,
        operandFormat: PropTypes.string,

        operator: PropTypes.string,

        tooltipMessage: MessagePropType,
        tooltipWidth: PropTypes.string,
        tooltipLocation: PropTypes.oneOf(LOCATION_OPTIONS),
        nubbinAlignment: PropTypes.oneOf(ALIGNMENT_OPTIONS),

        result: PropTypes.bool,
    })).isRequired,
};

CalculationLineBlock.defaultProps = {
    title: undefined,
};

CalculationLineBlock.Container = styled.summary`
    box-sizing: border-box;

    padding: ${Sizes.SPACING.TWO} 0 0;
    width: 100%;
`;

export default CalculationLineBlock;
